import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BinarySelectGroup } from "../../../binary-select/binary-select-group/BinarySelectGroup";
import { getStateHandlers } from "./getStateHandlers";
export const CheckboxGroup = forwardRef(({ selection, layout = "column", onChange, ...props }, ref) => (_jsx(BinarySelectGroup, { ref: ref, "data-testid": "CheckboxGroup", layout: layout, 
    // @ts-expect-error - from <BinarySelectGroup> types, which should be generic, but are
    // difficult to make so due to forwardRef not being able to handle generic components.
    onChange: onChange, ...getStateHandlers(selection), ...props })));
CheckboxGroup.displayName = "CheckboxGroup";
